const encodeVariantValues = (variant) => {
    var _a;
    let encoding = '?att=';
    if (!variant) {
        return (encoding = '');
    }
    try {
        encoding += universalEncode((_a = variant.values) === null || _a === void 0 ? void 0 : _a.join('|'));
    }
    catch (_b) {
        // Cannot be encoded
        encoding = '';
    }
    return encoding;
};
function universalEncode(str) {
    if (__IN_SERVER__) {
        return new Buffer(str).toString('base64');
    }
    else {
        return btoa(str);
    }
}
export default encodeVariantValues;
//# sourceMappingURL=encodeVariant.js.map